
import { ShopHereBtn } from '../Template'
import './landing_page.css'
import './landing_page_desktop.css'

export default function LandingPage() {

    return (
        <div className="landingpg-container">
            <div id="landingpg-content">
                <div id="landingpg-greeting">
 
                    <h1 className='landingpg-greeting-txt'>Crochetedly, Tori</h1>
                    <h3 className='landingpg-greeting-txt'>Handmaking cute crocheted apparel and accessories for you!</h3>
                    <p className='landingpg-greeting-txt'>Click the button below to visit my shop and see what's for sale. Otherwise, have a look through this site to see what I can make! DM me on any of my socials if you would like to order something that is not in the shop below.</p>
                    <div className='landingpg-greeting-txt'>
                        <ShopHereBtn />
                    </div>
                </div>
                <div className="greeting-img-container">
                    <img className="landing-content" src="/img/tori._cropped.webp" />
                </div>
            </div>
        </div>
    )
}

